export default "__VITE_ASSET__rlBP8HKn__"